import {AfterViewInit, Component, OnDestroy} from '@angular/core';
import {Lesson} from '../models/lesson.model';
import {select, Store} from '@ngrx/store';
import {AppState} from '../store';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {coursePageDataSelector} from '../course-page/course-page-selectors';
import {CoursePageData} from '../course-page/course-page-data.model';
import {Course} from '../models/course.model';
import {UrlBuilderService} from '../services/url-builder.service';
import {DataService} from './services/data-service.service';
import {tap} from 'rxjs/operators';
import {TranslateModule} from '@ngx-translate/core';

import {CourseListComponent} from './course-list/course-list.component';
import {PricingInfoComponent} from './pricing-info/pricing-info.component';
import {AsyncPipe, NgFor, NgIf} from '@angular/common';
import {StatsInfoComponent} from './stats-info/stats-info.component';
import {environment} from '../../environments/environment';
import {formatDuration} from '../shared/pipes/format-duration .pipe';

@Component({
    selector: 'course-embed',
    templateUrl: './course-embed.component.html',
    styleUrls: ['./course-embed.component.scss'],
    imports: [
    NgIf,
    NgFor,
    PricingInfoComponent,
    CourseListComponent,
    AsyncPipe,
    TranslateModule,
    StatsInfoComponent,
    formatDuration
]
})
export class CourseEmbedComponent implements AfterViewInit, OnDestroy {
  sectionsLessons: {
    [key: string]: { sectionLessons: Lesson[]; sectionStartIndex: number };
  } = {};

  courseData$: Observable<CoursePageData>;
  subscription$: Subscription;
  footerLogoUrl: string;
  salesPageBannerColor: string

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private ub: UrlBuilderService,
    private dataService: DataService,
  ) {
  }

  ngOnInit() {
    this.footerLogoUrl = this.ub.buildImageUrl('/images/icons/OnlineHost.svg');
    this.subscription$ = new Subscription();
    const spinnerNodes = document.getElementsByClassName(
      'spinner'
    );

    const appRootNode = document.getElementsByTagName(
      'app-root'
    )[0] as HTMLElement;
    appRootNode.style.display = ' flex';
    appRootNode.style.justifyContent = ' center';

    const body = document.body;
    body.style.background = 'transparent';

    const s$ = this.dataService.viewCheckedEventListener().subscribe(info => {
      Array.from(spinnerNodes).forEach((spinnerNode: HTMLElement) => {
        spinnerNode.style.display = 'none';
      });
    });

    this.subscription$.add(s$);

    const html = document.getElementsByTagName('html')[0] as HTMLElement;
    html.style.overflow = 'hidden';

    this.courseData$ = this.store
      .pipe(
        select(coursePageDataSelector),
        tap(data => {
          this.salesPageBannerColor = data?.tenant?.brandTheme?.salesPageBannerColor ?? data?.tenant?.brandTheme?.primaryColor;
        })
      );
  }

  thumbnailUrl(course: Course) {
    return this.ub.buildCourseThumbnailUrl(course) ?? 'https://d8avu785lzlph.cloudfront.net/images/empty-image.png';
  }

  authorImage(author) {
    return author?.[0].pictureUrl ?? 'https://d8avu785lzlph.cloudfront.net/images/empty-image.png';
  }

  isAuthorImage(author) {
    return !!author?.[0]?.pictureUrl;
  }

  openCourseInNewTab(data: CoursePageData) {

    const {customDomain, subDomain} = data?.tenant;

    const courseUrl = data?.course.url;

    const protocol = (environment.production || environment.test) ? 'https' : 'http';

    const domainName = customDomain ? customDomain : `${subDomain}.${environment.domainName}`;

    const url = `${protocol}://${domainName}/courses/${courseUrl}`;

    window.open(url, '_blank');

  }

  openOnlineCourseHostInNewTab($event) {
    const url = `https://onlinecoursehost.com/`;
    window.open(url, '_blank');
    $event.stopPropagation();
  }

  ngAfterViewInit() {
    const course_embed_container = document.getElementsByClassName(
      'course-embed-container'
    )[0] as HTMLElement;
    course_embed_container.style.backgroundColor = this.salesPageBannerColor;
  }
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }

}
